/* eslint-disable max-len */
/* THIS IS GENERATED BY generateBlockMaps.js - PLEASE DO NOT EDIT */
import {
    ProductTableBestMortgageRates,
    ProductTableMortgageProviderRates,
    ProductTableMortgages,
    ProductTableMortgagesSEO,
} from '@ratehub/web-components';


const BLOCK_TO_COMPONENT_MAP = {
    [ProductTableBestMortgageRates.blockKey]: { render: ProductTableBestMortgageRates },
    [ProductTableMortgageProviderRates.blockKey]: { render: ProductTableMortgageProviderRates },
    [ProductTableMortgages.blockKey]: { render: ProductTableMortgages },
    [ProductTableMortgagesSEO.blockKey]: { render: ProductTableMortgagesSEO },
};

export default BLOCK_TO_COMPONENT_MAP;
